import { Component, OnInit } from '@angular/core';
import { NgxSpinnerService } from "ngx-spinner";
import { QueryWrapper } from '../../model/query-wrapper.model';
import { DelayedDispatchService } from '../../service/delayed-dispatch.service';
import { saveAs } from 'file-saver';
import { SelectItem, MessageService, ToastMessageOptions } from 'primeng/api';
import { AppMessage } from '../../model/messages.model';

@Component({
  selector: 'app-allo-reports',
  templateUrl: './allo-reports.component.html',
  styleUrls: ['./allo-reports.component.css'],
  standalone: false // NOSONAR
})
export class AlloReportsComponent implements OnInit {

  errMsgs: ToastMessageOptions[] = [];
  periods: SelectItem[] = [];
  selectedPeriod: string;
  domiciles: SelectItem[] = [];
  namcs: SelectItem[] = [];
  selectedDomiciles: any[];
  selectedNamcs: any[];
  selectedReports: string[] = [];
  fiscalYears: SelectItem[] = [];
  fiscalYear: string;
  designPatterns: SelectItem[] = [];
  designPattern: string;
  isNamcSelected: boolean = true;
  isDomicileSelected: boolean = true;
  plantReportSelected: boolean = false;
  supplierReportSelected: boolean = false;
  dockReportSelected: boolean = false;
  crossDockReportSelected: boolean = false;
  calendarReportSelected: boolean = false;
  baseLineReportSelected: boolean = false;
  transporterReportSelected: boolean = false;
  partSupppDockReportSelected: boolean = false;
  const_msg = 'No Data Available!';
  const_msg1 = "The Calendar Report has been generated successfully."

  constructor(private readonly service: DelayedDispatchService,
    private readonly spinnerService: NgxSpinnerService,
    private readonly messageService: MessageService
  ) { }

  ngOnInit() { // NOSONAR
    this.service.getDomiciles().subscribe(data => {
      this.setDomiciles(data);
    });
    this.service.getNamcs().subscribe(data => {
      this.setNamcs(data);
    });
    this.service.getPeriods().subscribe(data => {
      this.periods = [];
      this.setPeriods(data);
    });
    this.getExistingFiscalYears();
    this.setDesignPatterns();
  }

  setDomiciles(data) {
    for (const entry of data.domiciles) {
      this.domiciles.push(
        { label: entry, value: entry }
      );
    }
  }

  setNamcs(data) {
    for (const entry of data.domiciles) {
      this.namcs.push(
        { label: entry, value: entry }
      );
    }
  }

  setPeriods(data) {
    for (const entry of data) {
      this.periods.push(
        { label: entry, value: entry }
      );
    }
  }

  getExistingFiscalYears() {
    this.service.getAlloFiscalYears().subscribe(data => {
      this.fiscalYears = [];
      this.setFiscalYears(data);
    }
    );
  }

  setFiscalYears(data) {
    for (const entry of data) {
      this.fiscalYears.push(
        { label: entry.fiscalYear, value: entry.fiscalYear }
      );
    }
  }

  setDesignPatterns() {
    this.designPatterns.push(
      { label: 'Base', value: 'Base' },
      { label: 'Final', value: 'Final' },
      { label: 'Sim', value: 'Sim' }
    );
  }

  generateReports() { // NOSONAR
    this.errMsgs = [];
    this.messageService.clear();
    const qw = new QueryWrapper();
    this.validateInputs();
    if (this.errMsgs.length == 0) { // NOSONAR

      qw.searchCriteriaMap['fiscalYear'] = this.fiscalYear;
      qw.searchCriteriaMap['domiciles'] = this.selectedDomicilesString();
      qw.searchCriteriaMap['namcs'] = this.selectedNamcsString();
      qw.searchCriteriaMap['period'] = this.selectedPeriod;
      qw.searchCriteriaMap['designPattern'] = this.designPattern;

      for (let i = 0; i < this.selectedReports.length; i++) {
        if (this.selectedReports[i] != null && this.selectedReports[i] == 'calendar') { // NOSONAR
          this.generateCalendarReport(qw);
        }

        if (this.selectedReports[i] != null && this.selectedReports[i] == 'baselineRoute') { // NOSONAR
          this.generateBaselineRouteReport(qw);
        }

        if (this.selectedReports[i] != null && this.selectedReports[i] == 'transRate') { // NOSONAR
          this.generateTransporterRateReport(qw);
        }

        if (this.selectedReports[i] != null && this.selectedReports[i] == 'partSuppDock') { // NOSONAR
          this.generatePartSupplierDockReport(qw);
        }

        if (this.selectedReports[i] != null && this.selectedReports[i] == 'dock') { // NOSONAR
          this.generateDockReport(qw);
        }

        if (this.selectedReports[i] != null && this.selectedReports[i] == 'plant') {// NOSONAR
          this.generatePlantReport(qw);
        }

        if (this.selectedReports[i] != null && this.selectedReports[i] == 'supplier') { // NOSONAR
          this.generateSupplierReport(qw);
        }

        if (this.selectedReports[i] != null && this.selectedReports[i] == 'crossDock') { // NOSONAR
          this.generateCrossDockReport(qw);
        }
      }
    }
  }

  generateCalendarReport(qw) {
    this.errMsgs = [];
    this.spinnerService.show();
    this.messageService.clear();
    this.service.getAlloCalendarReport(qw).subscribe(
      (response: any) => {
        this.errMsgs = [];
        if (response) {
          this.errMsgs.push({ severity: 'success', summary: this.const_msg1, detail: this.const_msg1 });
          this.messageService.addAll([{ severity: 'success', summary: this.const_msg1, detail: '' }]);

          this.saveToFile(response, "Allo_Calendar.csv");
        }
        else {
          this.errMsgs.push({
            severity: 'error',
            summary: this.const_msg,
            detail: ''
          });
        }
        this.spinnerService.hide();
      },
      (error: any) => {
        this.errMsgs = [];
        this.errMsgs.push({ severity: 'error', summary: error.message, detail: '' });
        this.messageService.add({ severity: 'error', summary: error.message, detail: '' });

        this.spinnerService.hide();
      }
    );
  }

  generateBaselineRouteReport(qw) {
    this.errMsgs = [];
    this.messageService.clear();
    this.spinnerService.show();
    this.service.getAlloBaselineReport(qw).subscribe(
      (response: any) => {
        this.errMsgs = [];
        if (response) {
          this.errMsgs.push({ severity: 'success', summary: "The Baseline Route Report has been generated successfully.", detail: '' });
          this.messageService.addAll([{ severity: 'success', summary: "The Baseline Route Report has been generated successfully.", detail: '' }]);

          this.saveToFile(response, "Allo_BaselineRoute.csv");
        }
        else {
          this.errMsgs.push({
            severity: 'error',
            summary: this.const_msg,
            detail: ''
          });
        }
        this.spinnerService.hide();
      },
      (error: any) => {
        this.errMsgs = [];
        this.errMsgs.push({ severity: 'error', summary: error.message, detail: '' });
        this.messageService.add({ severity: 'error', summary: error.message, detail: '' });

        this.spinnerService.hide();
      }
    );
  }

  generateTransporterRateReport(qw) {
    this.messageService.clear();
    this.errMsgs = [];
    this.spinnerService.show();
    this.service.getAlloTransporterReport(qw).subscribe(
      (response: any) => {
        this.errMsgs = [];
        if (response) {
          this.errMsgs.push({ severity: 'success', summary: "The Transporter Rate Report has been generated successfully.", detail: '' });
          this.messageService.addAll([{ severity: 'success', summary: "The Transporter Rate Report has been generated successfully.", detail: '' }]);

          this.saveToFile(response, "Allo_TransporterRate.csv");
        }
        else {
          this.errMsgs.push({
            severity: 'error',
            summary: this.const_msg,
            detail: ''
          });
        }
        this.spinnerService.hide();
      },
      (error: any) => {
        this.errMsgs = [];
        this.errMsgs.push({ severity: 'error', summary: error.message, detail: '' });
        this.messageService.add({ severity: 'error', summary: error.message, detail: '' });

        this.spinnerService.hide();
      }
    );
  }

  generatePartSupplierDockReport(qw) {
    this.errMsgs = [];
    this.messageService.clear();
    this.spinnerService.show();
    this.service.getAlloPartSupplierDockReport(qw).subscribe(
      (response: any) => {
        this.errMsgs = [];
        if (response) {
          this.errMsgs.push({ severity: 'success', summary: "The Part Supplier Dock Report has been generated successfully.", detail: '' });
          this.messageService.addAll([{ severity: 'success', summary: "The Part Supplier Dock Report has been generated successfully.", detail: '' }]);

          this.saveToFile(response, "Allo_PartSupplierDock.csv");
        }
        else {
          this.errMsgs.push({
            severity: 'error',
            summary: this.const_msg,
            detail: ''
          });
        }

        this.spinnerService.hide();
      },
      (error: any) => {
        this.errMsgs = [];
        this.errMsgs.push({ severity: 'error', summary: error.message, detail: '' });
        this.messageService.add({ severity: 'error', summary: error.message, detail: '' });

        this.spinnerService.hide();
      }
    );
  }

  generateDockReport(qw) {
    this.errMsgs = [];
    this.messageService.clear();
    this.spinnerService.show();
    this.service.getAlloDockReport(qw).subscribe(
      (response: any) => {
        this.errMsgs = [];
        if (response) {
          this.errMsgs.push({ severity: 'success', summary: "The Dock Report has been generated successfully.", detail: '' });
          this.messageService.addAll([{ severity: 'success', summary: "The Dock Report has been generated successfully.", detail: '' }]);
          this.saveToFile(response, "Allo_Dock.csv");
        }
        else {
          this.errMsgs.push({
            severity: 'error',
            summary: this.const_msg,
            detail: ''
          });
        }
        this.spinnerService.hide();
      },
      (error: any) => {
        this.errMsgs = [];
        this.errMsgs.push({ severity: 'error', summary: error.message, detail: '' });
        this.messageService.add({ severity: 'error', summary: error.message, detail: '' });

        this.spinnerService.hide();
      }
    );
  }

  generatePlantReport(qw) {
    this.errMsgs = [];
    this.spinnerService.show();
    this.service.getAlloPlantReport(qw).subscribe(
      (response: any) => {
        this.errMsgs = [];
        if (response) {
          this.errMsgs.push({ severity: 'success', summary: "The Plant Report has been generated successfully.", detail: '' });
          this.messageService.addAll([{ severity: 'success', summary: "The Plant Report has been generated successfully.", detail: '' }]);

          this.saveToFile(response, "Allo_Plant.csv");
        }
        else {
          this.errMsgs.push({
            severity: 'error',
            summary: this.const_msg,
            detail: ''
          });
        }
        this.spinnerService.hide();
      },
      (error: any) => {
        this.errMsgs = [];
        this.errMsgs.push({ severity: 'error', summary: error.message, detail: '' });
        this.messageService.add({ severity: 'error', summary: error.message, detail: '' });

        this.spinnerService.hide();
      }
    );
  }

  generateSupplierReport(qw) {
    this.errMsgs = [];
    this.spinnerService.show();
    this.messageService.clear();
    this.service.getAlloSupplierReport(qw).subscribe(
      (response: any) => {
        this.errMsgs = [];
        if(response)
        {
        this.errMsgs.push({ severity: 'success', summary: "The Supplier Report has been generated successfully.", detail: '' });
        this.messageService.addAll([{ severity: 'success', summary: "The Supplier Report has been generated successfully.", detail: '' }]);
        this.saveToFile(response, "Allo_Supplier.csv");
        }
        else {
          this.errMsgs.push({
            severity: 'error',
            summary: this.const_msg,
            detail: ''
          });
        }
        this.spinnerService.hide();
      },
      (error: any) => {
        this.errMsgs = [];
        this.errMsgs.push({ severity: 'error', summary: error.message, detail: '' });
        this.messageService.add({ severity: 'error', summary: error.message, detail: '' });
        this.spinnerService.hide();
      }
    );
  }

  generateCrossDockReport(qw) {
    this.errMsgs = [];
    this.messageService.clear();
    this.spinnerService.show();
    this.service.getAlloCrossDockReport(qw).subscribe(
      (response: any) => {
        this.errMsgs = [];
        if(response)
        {
        this.errMsgs.push({ severity: 'success', summary: "The CrossDock Report has been generated successfully.", detail: '' });
        this.messageService.addAll([{ severity: 'success', summary: "The CrossDock Report has been generated successfully.", detail: '' }]);

        this.saveToFile(response, "Allo_CrossDock.csv");
        }
        else {
          this.errMsgs.push({
            severity: 'error',
            summary: this.const_msg,
            detail: ''
          });
        }
        this.spinnerService.hide();
      },
      (error: any) => {
        this.errMsgs = [];
        this.errMsgs.push({ severity: 'error', summary: error.message, detail: '' });
        this.messageService.add({ severity: 'error', summary: "Something went wrong while generating Connection Check report.", detail: '' });
        this.spinnerService.hide();
      }
    );
  }

  validateInputs() { // NOSONAR
    this.errMsgs = [];
    this.messageService.clear();
    if (this.selectedReports.length == 0) { // NOSONAR
      this.setMessage('error', 'Atleast one report must be selected.');
    }
    for (let i = 0; i < this.selectedReports.length; i++) {
      if (this.selectedReports[i] != null && this.selectedReports[i] == 'calendar') { // NOSONAR
        this.calendarReportSelected = true;
      }
      if (this.selectedReports[i] != null && this.selectedReports[i] == 'baselineRoute') { // NOSONAR
        this.baseLineReportSelected = true;
      }
      if (this.selectedReports[i] != null && this.selectedReports[i] == 'transRate') { // NOSONAR
        this.transporterReportSelected = true;
      }
      if (this.selectedReports[i] != null && this.selectedReports[i] == 'partSuppDock') { // NOSONAR
        this.partSupppDockReportSelected = true;
      }
      if (this.selectedReports[i] != null && this.selectedReports[i] == 'dock') { // NOSONAR
        this.dockReportSelected = true;
      }
      if (this.selectedReports[i] != null && this.selectedReports[i] == 'plant') { // NOSONAR
        this.plantReportSelected = true;
      }
      if (this.selectedReports[i] != null && this.selectedReports[i] == 'supplier') {// NOSONAR
        this.supplierReportSelected = true;
      }
      if (this.selectedReports[i] != null && this.selectedReports[i] == 'crossDock') { // NOSONAR
        this.crossDockReportSelected = true;
      }
    }

    if (this.partSupppDockReportSelected || this.transporterReportSelected || this.baseLineReportSelected) {
      if (this.selectedPeriod == null) { // NOSONAR
        this.setMessage('error', 'Period must be selected.');
      }
    }

    if (this.partSupppDockReportSelected || this.transporterReportSelected || this.baseLineReportSelected || this.calendarReportSelected) {
      if (this.selectedDomiciles == null && this.selectedNamcs == null) { // NOSONAR
        this.setMessage('error', 'Atleast one NAMC/Domicile must be selected.');
      }
    }

    if (this.crossDockReportSelected || this.partSupppDockReportSelected || this.transporterReportSelected) {
      if (this.fiscalYear == null) { // NOSONAR
        this.setMessage('error', 'Fiscal Year must be selected.');
      }
    }

    if (this.baseLineReportSelected && this.designPattern == null) { // NOSONAR
      this.setMessage('error', 'Design Pattern must be selected for Baseline Route Report.');
    }
  }

  setMessage(type, desc) {
    this.errMsgs.push({ severity: type, summary: desc, detail: '' });
  }

  messageHandler(data) {
    this.messageHandlerType(data, 'error');
  }

  messageHandlerType(data, type) {
    this.errMsgs = [];
    if (data.messages != undefined && data.messages.length != 0) { // NOSONAR
      for (const entry of data.messages) {
        for (const mes of entry.message.sort()) {
          this.setMessage(type, mes);
        }
      }
      return;
    }
  }

  selectedDomicilesString() {
    return this.selectedDomiciles ? this.selectedDomiciles.toString().replace(/,/g, ',') : '';
  }

  selectedNamcsString() {
    return this.selectedNamcs ? this.selectedNamcs.toString().replace(/,/g, ',') : '';
  }

  saveToFile(response, fileName) {
    saveAs(response, fileName);
  }

  onChangeNamc(_changeField: string) {
    this.errMsgs = [];
    if (this.selectedNamcs.length > 0) {
      this.isDomicileSelected = false;
    } else {
      this.isDomicileSelected = true;
    }
  }

  onChangeDomicile(_changeField: string) {
    this.errMsgs = [];
    if (this.selectedDomiciles.length > 0) {
      this.isNamcSelected = false;
    } else {
      this.isNamcSelected = true;
    }
  }

  onChangeTransReport(isChecked: boolean) {
    this.transporterReportSelected = isChecked;
    for (let i = 0; i < this.selectedReports.length; i++) {
      if (this.selectedReports[i] != null && this.selectedReports[i] == 'transRate') { // NOSONAR
        this.transporterReportSelected = isChecked;
      }
    }
  }

  onChangeCalReport(isChecked: boolean) {
    this.calendarReportSelected = isChecked;
    for (let i = 0; i < this.selectedReports.length; i++) {
      if (this.selectedReports[i] != null && this.selectedReports[i] == 'calendar') { // NOSONAR
        this.calendarReportSelected = isChecked;
      }
    }
  }

  onChangeBaselineReport(isChecked: boolean) {
    this.baseLineReportSelected = isChecked;
    for (let i = 0; i < this.selectedReports.length; i++) {
      if (this.selectedReports[i] != null && this.selectedReports[i] == 'baselineRoute') { // NOSONAR
        this.baseLineReportSelected = isChecked;
      }
    }
  }

  onChangePartsSuppDockReport(isChecked: boolean) {
    this.partSupppDockReportSelected = isChecked;
    for (let i = 0; i < this.selectedReports.length; i++) {
      if (this.selectedReports[i] != null && this.selectedReports[i] == 'partSuppDock') { // NOSONAR
        this.partSupppDockReportSelected = isChecked;
      }
    }
  }

  onChangeCrossDockReport(isChecked: boolean) {
    this.crossDockReportSelected = isChecked;
    for (let i = 0; i < this.selectedReports.length; i++) {
      if (this.selectedReports[i] != null && this.selectedReports[i] == 'crossDock') { // NOSONAR
        this.crossDockReportSelected = isChecked;
      }
    }
  }

}
